import { createContext } from "react";
import {
  IMerchant,
  ILoginPayload,
  ISignUpPayload,
  IAccountOption,
  IIntegrationOption,
  IUserPreferences,
  IViewAsPayload,
} from "../interfaces";
import { RouteConfig } from "../config/routes";

export interface AuthContextType {
  user: IMerchant | null;
  permittedRoutes: RouteConfig[];
  isAuthenticated: boolean;
  isLoading: boolean;
  selectedAccount: IAccountOption;
  selectedIntegration: IIntegrationOption | null;
  teams: IMerchant[];
  loggingOut: boolean;
  sessionId: string;
  wsConnected: boolean;
  lastPing: {
    status?: string;
    uptime?: number;
    downtime?: number;
    last_ping_time?: string;
  } | null;
  sendLogout: (logoutPayload: {
    type: string;
    user_id: string;
    session_id: string;
    time: string;
  }) => boolean;
  login: (credentials: ILoginPayload) => Promise<void>;
  takeOverLogin: (credentials: IViewAsPayload) => Promise<void>;
  logout: () => void;
  signup: (userData: ISignUpPayload) => Promise<void>;
  setUser: (user: IMerchant | null) => void;
  setSelectedAccount: (account: IAccountOption) => void;
  setSelectedIntegration: (integration: IIntegrationOption) => void;
  updatePreferences: (preferences: IUserPreferences) => Promise<IMerchant>;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);
